import React, { useState, useCallback, useContext, useEffect, useRef } from 'react'
import { Form } from 'semantic-ui-react'
import ImageRatingButtonList from 'components/NewQuestion/ImageRatingButtonList'
import { QuestionBuilderContext } from 'organisms/QuestionBuilderCard'
import { RatingScaleButtonGroup } from 'components/RatingScaleButtonGroup'
import { CsatChoiceInput } from 'organisms/CsatChoiceInput'
import { surveySettingContext } from 'pages/SurveySettings/context'
import constants from 'config/constants'

export function CsatInput() {
  const {
    question,
    dispatch,
    handleFieldChange,
    iconSetId,
    defaultIconSetId,
    iconSet,
    defaultIconSet,
    iconSetOptions,
  } = useContext(QuestionBuilderContext)

  const { setContext: setSurveySettingContext } = useContext(surveySettingContext)

  const [selectedScale, setSelectedScale] = useState(question.choices.length)
  const previousScaleRef = useRef(selectedScale)

  useEffect(() => {
    setSurveySettingContext({ isSurveyBuilderDirty: false })
  }, [setSurveySettingContext])

  useEffect(() => {
    if (previousScaleRef.current === selectedScale) {
      return
    }

    previousScaleRef.current = selectedScale
    const ratings = constants.SCALE_RATING[selectedScale]

    const newChoices = ratings.map((rating) => {
      const existingChoice = question.choices.find((choice) => choice.value == rating)
      if (existingChoice) {
        return existingChoice
      }

      return constants.DEFAULT_CSAT_LABEL_STATE.find((choice) => choice.value == rating)
    })

    handleFieldChange('choices', () => newChoices)()
  }, [selectedScale, question.choices, handleFieldChange])

  const createOnChange = useCallback(
    (index) => (value) => {
      handleFieldChange(`choices.${index}.label`, () => value)()
    },
    [handleFieldChange]
  )

  const csatIconSets = iconSetOptions.filter((icon) => icon.metric === 'CSAT')

  return (
    <>
      <Form.Field>
        <label>Icon set</label>
        <ImageRatingButtonList
          iconSetId={iconSetId || defaultIconSetId}
          onClick={(iconSet) => {
            dispatch({ type: 'SET_ICON_SET', iconSet })
            handleFieldChange('choiceIconSet', () => iconSet)()
          }}
          iconSetOptions={csatIconSets}
          defaultPreviewIconSetImageKey="choice_value_4"
        />
      </Form.Field>

      <Form.Field>
        <label>Rating scale</label>
        <RatingScaleButtonGroup scale={selectedScale} onChange={setSelectedScale} />
      </Form.Field>

      <Form.Field>
        <label>Choices</label>
        <CsatChoiceInput
          choices={question.choices}
          scale={selectedScale}
          createOnChange={createOnChange}
          iconSet={iconSet || defaultIconSet}
        />
      </Form.Field>
    </>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CsatInput/index.js